import { ChangeEvent, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Input } from '@opendoor/bricks/core';

import { PhoneQuestion } from 'src/lib/flow/FlowQuestion';
import { useAppSelector } from 'src/store/hooks';
import { errorAnswer } from 'src/store/sellerFlow/actions';
import { isInExclusiveOffersTreatment } from 'src/store/sellerFlow/selectors';
import { changeAnswers } from 'src/store/sellerInput';

import QuestionLabel from '../common/QuestionLabel';
import { trackAnswerChange } from './trackAnswerChange';

type PhoneInputProps = {
  question: PhoneQuestion;
  value?: string;
};

const PhoneInput: React.FC<PhoneInputProps> = ({ question, value }) => {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const { key, placeholder, optional, label } = question;
  const inExclusiveOfferTreatment = useAppSelector(isInExclusiveOffersTreatment);

  const onChange = (
    _event: ChangeEvent<HTMLInputElement>,
    newValue: string | undefined,
    validFormat?: boolean,
  ) => {
    const answer = newValue ?? null;

    //const { onAnswerChange } = this.props;
    let errorMessage: string | undefined;

    if (!validFormat) {
      errorMessage = 'Hm, looks like that wasn’t a valid phone number. Try again?';
    }

    if (errorMessage) {
      setErrorMessage(errorMessage);
      dispatch(errorAnswer(key, true, errorMessage));
    } else {
      // clear our previous error message
      setErrorMessage(undefined);
      dispatch(errorAnswer(key, false));
    }

    dispatch(changeAnswers([{ key, answer }]));
    trackAnswerChange(key, newValue ?? undefined);
  };

  const width = inExclusiveOfferTreatment ? '100%' : ['100%', '100%', '600px'];
  const maxWidth = inExclusiveOfferTreatment ? ['375px', null, '560px'] : ['100%', '600px'];

  return (
    <Input
      analyticsName="reception-fe-question-phone-number"
      type="tel"
      // this makes it so the * for required inputs shows next to the label instead of below
      labelStyles={{ display: 'flex' }}
      label={<QuestionLabel title={label} unboundedWidth />}
      onChange={onChange}
      onBlur={() => trackAnswerChange(key, value)}
      value={value}
      fontSize="s0"
      placeholder={placeholder}
      id={`phone-${key}`}
      name={key}
      invalid={!!errorMessage}
      errorMessage={errorMessage}
      autoComplete="tel"
      required={!optional}
      //unboundedWidth={unboundedWidth}
      maxWidth={maxWidth}
      width={width}
    />
  );
};

export default PhoneInput;
